import dayjs from 'dayjs';

export const formatTime = (timeString, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (timeString === null || timeString === undefined) {
        return ''; //如果是空，返回空字符串
    }
    return dayjs(timeString).format(format);
};